<template>
  <v-container fluid class="salessummary-list mt-3">
    <v-row class="ma-0">
      <v-card width="100%" class="ma-1">
        <v-card-text>
          <v-row no-gutters>
            <v-col v-if="query.userid!=null" cols="12" md="3" class="d-flex justify-space-between justify-md-start">
                <div>
                  <v-avatar v-if="users.find(user=>user._id == query.userid)['userimage']!==''" size="40">
                    <img v-bind:src="users.find(user=>user._id == query.userid)['userimage']" alt="">
                  </v-avatar>
                  <v-avatar v-else color="warning" size="40">
                    <span class="white--text headline">{{ users.find(user=>user._id == query.userid)['username'][0].toUpperCase() }}</span>
                  </v-avatar>
                  <span style="margin-left:15px">{{ users.find(user=>user._id == query.userid)['username'] }}</span>
                </div>
            </v-col>
            <v-col cols="12" md="3" class="d-flex justify-space-between justify-md-start">
              <div>
                <div style="display: block; margin: 0;" v-if="query.locationid!=null"><span><b>Location:</b> {{ locations.find(location=>location._id == query.locationid)['locationname'] }}</span></div> 
                <div style="display: block; margin: 0;" v-if="query.startdate!=null || query.enddate!=null"><b>Date Range:</b> {{ query.startdate }} - {{ query.enddate }}</div> 
              </div>
            </v-col>
            <v-spacer></v-spacer>
            <v-col cols="12" md="3" class="d-flex justify-space-between justify-md-end">
              <v-btn 
                color="success" 
                class="button-shadow mr-3"
                @click="findSalesSummaryDialog = true"
              >
                <v-icon class="mr-2">mdi-account-search</v-icon>
                Find
              </v-btn>
              <download-excel
                class="btn btn-default"
                :data="getJson()"
                worksheet="My Worksheet"
                type="xls"
                :name="getFileName()"
              >
              <v-btn 
                v-show="salessummaries.length>0"
                color="default" 
                class="button-shadow mb-2 mr-0 mr-sm-2"
              >
                <v-icon class="mr-2">mdi-microsoft-excel</v-icon>
                Save
              </v-btn>
              </download-excel>

            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-card class="ma-1">
          <v-card-text>
            <v-data-table
              :loading="isReceiving || isDeleting"
              loading-text="Loading... Please wait"
              class="salessummaries-table"
              single-select
              item-key="_id"
              sort-by="salessummaryname"
              :footer-props="footer"
              :headers="headers"
              :items="salessummaries"
              :items-per-page="itemPerPage">
              <template v-slot:item.userimage="{ item }">
                <v-img aspect-ratio="1" v-bind:src="item.userimage" width="70"></v-img>
              </template>
              <template v-slot:item.username="{ item }">
                <p class="two-line">{{ item.username }}</p>
                <p class="two-line">{{ item.locationid!=undefined && locations.length>0 ? locations.find(location=>location._id == item.locationid)['locationname'] : '' }}</p>
              </template>
              <template v-slot:item.customerCount="{ item }">
                {{ item.customerCount!==null ? (item.customerCount).toFixed(0) : '' }}
              </template>
              <template v-slot:item.orderCount="{ item }">
                {{ item.orderCount!==null ? (item.orderCount).toFixed(0) : '' }}
              </template>
              <template v-slot:item.visitCount="{ item }">
                {{ item.visitCount!==null ? (item.visitCount).toFixed(0) : '' }}
              </template>
              <template v-slot:item.totalQuantity="{ item }">
                {{ item.totalQuantity!==null ? (item.totalQuantity).toFixed(1) : '' }}
              </template>
              <template v-slot:item.totalAmount="{ item }">
                {{ item.totalAmount!==null ? (item.totalAmount).toFixed(1) : '' }}
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row justify="center">
    <v-dialog
      v-model="findSalesSummaryDialog"
      persistent
      max-width="600px"
    >
      <v-card>
        <v-card-title>
          <span class="text-h5">Find Sales Summary</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col
                cols="12"
                sm="12"
                md="12"
              >
                <v-select
                  :items="locations.filter(x=>x.locationstatus=='Active').map(x => {
                            return {text: x.locationname, value: x._id};
                          })"
                  v-model="query.locationid"
                  label="Location"
                  required
                ></v-select>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                        <v-menu
                          ref="menu_startdate"
                          v-model="menu_startdate"
                          :close-on-content-click="false"
                          :return-value.sync="query.startdate"
                          transition="scale-transition"
                          offset-y
                          min-width="auto"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              outlined
                              dense
                              v-model="query.startdate"
                              label="Start Date"
                              v-bind="attrs"
                              v-bind:value="query.startdate"
                              v-on="on"
                              persistent-hint
                              single-line hint="Please enter start date">
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-model="query.startdate"
                            no-title
                            scrollable
                          >
                            <v-spacer></v-spacer>
                            <v-btn
                              text
                              color="primary"
                              @click="menu_startdate = false"
                            >
                              Cancel
                            </v-btn>
                            <v-btn
                              text
                              color="primary"
                              @click="$refs.menu_startdate.save(query.startdate)"
                            >
                              OK
                            </v-btn>
                          </v-date-picker>
                        </v-menu>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                        <v-menu
                          ref="menu_enddate"
                          v-model="menu_enddate"
                          :close-on-content-click="false"
                          :return-value.sync="query.enddate"
                          transition="scale-transition"
                          offset-y
                          min-width="auto"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              outlined
                              dense
                              v-model="query.enddate"
                              label="End Date"
                              v-bind="attrs"
                              v-bind:value="query.enddate"
                              v-on="on"
                              persistent-hint
                              single-line hint="Please enter end date">
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-model="query.enddate"
                            no-title
                            scrollable
                          >
                            <v-spacer></v-spacer>
                            <v-btn
                              text
                              color="primary"
                              @click="menu_enddate = false"
                            >
                              Cancel
                            </v-btn>
                            <v-btn
                              text
                              color="primary"
                              @click="$refs.menu_enddate.save(query.enddate)"
                            >
                              OK
                            </v-btn>
                          </v-date-picker>
                        </v-menu>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="query = {}"
          >
            Clear
          </v-btn>
          <v-btn
            color="blue darken-1"
            text
            @click="findSalesSummaryDialog = false"
          >
            Close
          </v-btn>
          <v-btn
            color="blue darken-1"
            text
            @click="findSalesSummary"
          >
            Find
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
  </v-container>
</template>

<script>
import { mapState, mapActions } from 'vuex';



export default {
  name: 'SalesSummaryByItem',
  data() {
    return {
      headers: [
        { text: 'Image', value: 'userimage', width: '8%'},
        { text: 'Name', value: 'username' },
        { text: 'New Customers', value: 'customerCount' },
        { text: 'Num of Visits', value: 'visitCount' },
        { text: 'Num of Orders', value: 'orderCount' },
        { text: 'Total Qty', value: 'totalQuantity' },
        { text: 'Total Sales', value: 'totalAmount' },
      ],
      footer: {'items-per-page-options': [500, 1000, 5000]},
      itemPerPage: 500,
      selected: [],
      findSalesSummaryDialog: false,
      query: {},
      salessummaries: [],
      menu_startdate: null,
      menu_enddate: null,
      offset: 0,
    }
  },
  computed: {
    ...mapState('SalesSummary', ['isDeleting', 'isReceiving']),
    ...mapState('Location', ['locations']),
    ...mapState('User', ['users']),
  },
  async created () {
    if(this.locations.length==0) this.getLocationsRequest();
    if(this.users.length==0) this.getUsersRequest();
  },
  methods: {
    ...mapActions('Location', ["getLocationsRequest"]),
    ...mapActions('User', ["getUsersRequest"]),
    ...mapActions('SalesSummary', ["getSalesSummaryByUser"]),
    async findSalesSummary(){
      this.findSalesSummaryDialog = false;
      let results;
      results = await this.getSalesSummaryByUser(this.query);
      this.salessummaries = [];
      for(var i=0; i<results.length; i++){
        let result = results[i];       
        if(result.orderCount!=null || result.visitCount!=null || result.customerCount!=null || result.totalQuantity!=null ){
          let item = Object.assign({}, result);
          this.salessummaries.push(item);
        }
      }
      this.salessummaries.push({
        customerCount: this.salessummaries.reduce(function (last, json) {return last + json.customerCount;}, 0),
        visitCount: this.salessummaries.reduce(function (last, json){return last + json.visitCount;}, 0),
        orderCount: this.salessummaries.reduce(function (last, json) {return last + json.orderCount;}, 0),
        totalQuantity: this.salessummaries.reduce(function (last, json) {return last + json.totalQuantity;}, 0),
        totalAmount: this.salessummaries.reduce(function (last, json) {return last + json.totalAmount;}, 0),
      });
    },
    getJson(){
      let json = this.salessummaries.map(report=>{return {
        username: report.username, 
        location: report.locationid!=undefined && this.locations.length>0 ? this.locations.find(location=>location._id == report.locationid)['locationname'] : '',
        newCustomer: report.customerCount,
        visitCount: report.visitCount,
        ordercount: report.orderCount,
        quantity: report.totalQuantity, 
        amount: report.totalAmount,
      }});
      return json;
    },
    getFileName(){
      var d = new Date();
      var name = 'sales-summary-' + d.getFullYear() + '-' + (d.getMonth()+1).toString() + '-' + d.getDate() + '-' + (d.getHours().toString() +d.getSeconds().toString());
      return name + '.xls';
    },
  },
}
</script>

<style src="./List.scss" lang="scss"></style>
